import { EventBus } from "../../../eventbus";

export default {
  props: {
    face: Object,
    isPlaceholder: Boolean,
  },
  methods: {
    handleUpdateFace() {
      if (this.face && !this.isPlaceholder) {
        EventBus.$emit(`faces--update`, this.face);
      }
    },
  },
};
